"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var function_enhancers_1 = require("@shopify/function-enhancers");

var memoizedGetDateTimeFormat = function_enhancers_1.memoize(getDateTimeFormat, dateTimeFormatCacheKey);

function formatDate(date, locales, options) {
  if (options === void 0) {
    options = {};
  } // Etc/GMT+12 is not supported in most browsers and there is no equivalent fallback


  if (options.timeZone != null && options.timeZone === 'Etc/GMT+12') {
    var adjustedDate = new Date(date.valueOf() - 12 * 60 * 60 * 1000);
    return memoizedGetDateTimeFormat(locales, tslib_1.__assign(tslib_1.__assign({}, options), {
      timeZone: 'UTC'
    })).format(adjustedDate);
  }

  return memoizedGetDateTimeFormat(locales, options).format(date);
}

exports.formatDate = formatDate;

function getDateTimeFormat(locales, options) {
  return Intl.DateTimeFormat(locales, options);
}

function dateTimeFormatCacheKey(locales, options) {
  return locales + "-" + JSON.stringify(options);
}